// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"47938":"06c9abed76868c3a","48846":"6438dbb375600f1b","60657":"1bd95b5a858d1212","68530":"5e9963699255a091"}[chunkId] + ".css";
};